import styled from '@emotion/styled';
import { Loader, Table } from 'semantic-ui-react';

export const LoadingRow = ({ colSpan, label }: { colSpan: number; label: string }) => (
  <Table.Row>
    <Table.Cell colSpan={colSpan}>
      <S.Content>
        <Loader active inline size="small" style={{ zIndex: 0 }} />
        <span>{label}</span>
      </S.Content>
    </Table.Cell>
  </Table.Row>
);

const S = {
  Content: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  `,
};
